/* eslint-disable react-hooks/exhaustive-deps */
import { ConfirmModal } from '@/components/modal'
import { BracketQueueLoading } from '@/components/skeleton'
import { LIMIT, OFFSET } from '@/constants/Common'
import { useGetBracketQueues, useRemoveBracketQueue } from '@/services'
import { BracketQueue } from '@/types'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
export const BracketQueues = () => {
  const { t } = useTranslation()

  const params = useParams()

  const { bracketId } = params

  const [offset, setOffset] = useState(OFFSET)
  const [queues, setQueues] = useState<BracketQueue[]>([])
  const [leagueMatchId, setLeagueMatchId] = useState<number | null>(null)
  const [confirmDelete, setConfirmDelete] = useState(false)
  const [lastElement, setLastElement] = useState<any>(null)

  const { data: resQueues, isLoading } = useGetBracketQueues(Number(bracketId), LIMIT, offset)
  const { isSuccess, isFetching } = useRemoveBracketQueue(leagueMatchId, confirmDelete)

  const observer = useRef(
    new IntersectionObserver((entries) => {
      const first = entries[0]
      if (first.isIntersecting) {
        setOffset((pre) => pre + LIMIT)
      }
    })
  )

  const openConfirmModal = (leagueMatchId: number) => setLeagueMatchId(leagueMatchId)

  const closeConfirmModal = () => setLeagueMatchId(null)

  useEffect(() => {
    const currentElement = lastElement
    const currentObserver = observer.current

    if (currentElement) {
      currentObserver.observe(currentElement)
    }

    return () => {
      if (currentElement) {
        currentObserver.unobserve(currentElement)
      }
    }
  }, [lastElement])

  useEffect(() => {
    if (resQueues) setQueues([...queues, ...resQueues.result.hits])
  }, [resQueues])

  useEffect(() => {
    if (isSuccess) {
      setLeagueMatchId(null)
      setConfirmDelete(false)
      setQueues([])
    }
  }, [isSuccess])

  return (
    <>
      <div className="flex flex-col gap-y-4">
        {queues?.map((item, index) => {
          const [team1, team2] = item.teams
          return index === queues.length - 1 && resQueues?.result.hasMore ? (
            <div key={item?.leagueMatchId} ref={setLastElement}>
              <div className="flex gap-x-6 bg-white rounded-2xl p-4 cursor-pointer">
                <span className="text-navy-900 text-sm font-semibold">{index + 1}</span>
                <div className="flex flex-1 gap-x-4 pt-4">
                  <div className="flex flex-col gap-y-4 flex-1 justify-between">
                    <span className="text-navy-900 font-semibold text-sm pl-4">{team1.player1.fullName}</span>
                    <div className="border-b border-dashed bg-green-500" />
                    <span className="text-navy-900 font-semibold text-sm pl-4">{team2.player1.fullName}</span>
                  </div>
                  <div className="flex items-center justify-center">
                    <div className="w-6 h-6 bg-green-300 rounded-full bg-opacity-50 text-green-500 font-medium text-xs flex items-center justify-center">
                      Vs
                    </div>
                  </div>
                  <div className="flex flex-col gap-y-4 flex-1 justify-between">
                    <span className="text-navy-900 font-semibold text-sm">{team1.player2.fullName}</span>
                    <div className="border-b border-dashed bg-green-500" />
                    <span className="text-navy-900 font-semibold text-sm">{team2.player2.fullName}</span>
                  </div>
                </div>
                <div>
                  <button
                    className="px-2 py-1 bg-primary-500 rounded text-xs font-semibold text-white hover:bg-opacity-70"
                    onClick={() => openConfirmModal(item.leagueMatchId)}
                  >
                    {t('event.exitTheQueue')}
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className="flex gap-x-6 bg-white rounded-2xl p-4 cursor-pointer" key={item?.leagueMatchId}>
              <span className="text-navy-900 text-sm font-semibold">{index + 1}</span>
              <div className="flex flex-1 gap-x-4 pt-4">
                <div className="flex flex-col gap-y-4 flex-1 justify-between">
                  <span className="text-navy-900 font-semibold text-sm pl-4">{team1.player1.fullName}</span>
                  <div className="border-b border-dashed bg-green-500" />
                  <span className="text-navy-900 font-semibold text-sm pl-4">{team2.player1.fullName}</span>
                </div>
                <div className="flex items-center justify-center">
                  <div className="w-6 h-6 bg-green-300 rounded-full bg-opacity-50 text-green-500 font-medium text-xs flex items-center justify-center">
                    Vs
                  </div>
                </div>
                <div className="flex flex-col gap-y-4 flex-1 justify-between">
                  <span className="text-navy-900 font-semibold text-sm">{team1.player2.fullName}</span>
                  <div className="border-b border-dashed bg-green-500" />
                  <span className="text-navy-900 font-semibold text-sm">{team2.player2.fullName}</span>
                </div>
              </div>
              <div>
                <button
                  className="px-2 py-1 bg-primary-500 rounded text-xs font-semibold text-white hover:bg-opacity-70"
                  onClick={() => openConfirmModal(item.leagueMatchId)}
                >
                  {t('event.exitTheQueue')}
                </button>
              </div>
            </div>
          )
        })}

        {(isLoading || isFetching) && (
          <>
            <BracketQueueLoading />
            <BracketQueueLoading />
            <BracketQueueLoading />
            <BracketQueueLoading />
            <BracketQueueLoading />
            <BracketQueueLoading />
          </>
        )}

        {resQueues && !resQueues?.result.hasMore && (
          <div className="flex justify-center">
            <span className="text-white font-semibold text-opacity-60">{t('common.noMoreResults')}</span>
          </div>
        )}
      </div>
      <ConfirmModal
        open={!!leagueMatchId}
        onClose={closeConfirmModal}
        title={`${t('event.exitTheQueue')}?`}
        desc={t('event.exitTheQueueDesc')}
        onSubmit={() => setConfirmDelete(true)}
        cancelTitle={t('common.goBack')}
        submitTitle={t('event.exitTheQueue')}
      />
    </>
  )
}
